<template>
  <div class="information">
    <Title text="会员信息" />
    <div>
      <van-cell-group>
        <van-field v-model.trim="info.contact" clearable label="联系人" placeholder="请填写联系人" />
        <van-field
          v-model.trim="info.phone"
          type="number"
          maxlength="11"
          clearable
          label="手机号"
          placeholder="请填写手机号"
        />
        <van-field v-model.trim="info.qq" type="number" clearable label="QQ" placeholder="请填写QQ号" />
        <van-field v-model.trim="info.email" clearable label="邮箱" placeholder="请填写邮箱" />
        <van-field
          readonly
          clickable
          label="职业类型"
          :value="info.jobType == null ? '' : info.jobType.text || info.jobType.desc"
          placeholder="选择职业类型"
          @click="careerShowPicker = true"
        />

        <van-popup v-model="careerShowPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="careers"
            @cancel="careerShowPicker = false"
            @confirm="onConfirm"
          />
        </van-popup>
        <van-field
          v-model.trim="info.telephone"
          type="number"
          clearable
          label="固定电话"
          placeholder="请填写固定电话"
        />
        <van-field
          readonly
          clickable
          label="企业类型"
          :value="info.companyType == null ? '' : info.companyType.text || info.companyType.desc"
          placeholder="选择企业类型"
          @click="firmShowPicker = true"
        />

        <van-popup v-model="firmShowPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="firms"
            @cancel="firmShowPicker = false"
            @confirm="onConfirmFrim"
          />
        </van-popup>
        <van-field v-model.trim="info.company" clearable label="企业名称" placeholder="请填写企业名称" />
      </van-cell-group>
    </div>
    <button class="save" @click="saveMessage">保存信息</button>
  </div>
</template>

<script>
import { MemInfo, SaveMemInfo } from "../request/api";
import Title from "../components/Title";
export default {
  name: "information",
  data() {
    return {
      info: {
        contact: "",
        phone: "",
        qq: "",
        email: "",
        telephone: "",
        jobType: "",
        companyType: "",
        company: ""
      },
      jobTypeValue: "",
      companyTypeValue: "",
      careerShowPicker: false,
      firmShowPicker: false,
      validateFlag: false,
      careers: [
        {
          value: 1,
          text: "工程师",
          enumName:'ENGINEER'
        },
        {
          value: 2,
          text: "采购商",
          enumName:'PURCHASERS'
        },
        {
          value: 3,
          text: "贸易商",
          enumName:'TRADERS'
        }
      ],
      firms: [
        {
          value: 1,
          text: "消费电子",
          enumName:'XFDZ'
        },
        {
          value: 2,
          text: "芯片原厂",
          enumName:'XPYC'
        },
        {
          value: 3,
          text: "物联网",
          enumName:'WLW'
        },
        {
          value: 4,
          text: "汽车电子",
          enumName:'QCDZ'
        },
        {
          value: 5,
          text: "测试仪器及设备",
          enumName:'CSYQJSB'
        },
        {
          value: 6,
          text: "智能手机与平板电脑",
          enumName:'ZNSJYPBDN'
        },
        {
          value: 7,
          text: "安防",
          enumName:'AF'
        },
        {
          value: 8,
          text: "智能交通",
          enumName:'ZNJT'
        },
        {
          value: 9,
          text: "医疗电子",
          enumName:'YLDZ'
        },
        {
          value: 10,
          text: "机器人",
          enumName:'JQR'
        },
        {
          value: 11,
          text: "其他",
          enumName:'QT'
        }
      ]
    };
  },
  components: {
    Title
  },
  created() {
    this.getMemInfo();
  },
  methods: {
    onConfirm(e) {
      this.info.jobType = e;
      this.careerShowPicker = false;
    },
    onConfirmFrim(e) {
      this.info.companyType = e;
      this.firmShowPicker = false;
    },
    //获取会员信息
    getMemInfo() {
      MemInfo({}).then(res => {
        if (res.data) {
          this.info = res.data;
        }
      });
    },
    //表单验证
    validations() {
      let phone = this.info.phone;
      let email = this.info.email;
      let phoneReg = /^13[\d]{9}$|^14[5,7]{1}\d{8}$|^15[^4]{1}\d{8}$|^17[0,3,6,7,8]{1}\d{8}$|^18[\d]{9}$/;
      var emailReg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (phone && !phoneReg.test(phone)) {
        this.$toast("请输入正确的手机格式");
      } else if (email && !emailReg.test(email)) {
        this.$toast("请输入正确的邮箱格式");
      } else {
        this.validateFlag = true;
      }
    },
    //保存验证
    saveMessage() {
      this.validations();
      if (this.validateFlag) {
        this.info.jobType = this.info.jobType.enumName;
        this.info.companyType = this.info.companyType.enumName;
        SaveMemInfo(this.info).then(res => {
          if (res.status == 200) {
            this.$toast.success({
              message: "信息保存成功",
              duration: 700
            });
            this.$router.push("/main");
          } else {
            this.$toast.fail({
              message: res.msg,
              duration: 700
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.information {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.save {
  width: 690px;
  height: 96px;
  border-radius: 10px;
  background: #ff9900;
  color: #fff;
  font-size: 36px;
  border: none;
  position: absolute;
  bottom: 30px;
  left: 30px;
}

</style>